import { useEffect } from 'react';
import { track } from '@spotify-internal/track-js';
import { GTM_PROVIDER_SUPPORT_ID } from '../ga/types';
const setUpTrackJs = (isCookieConsentEnabled, trackConfig = {}) => {
    if (isCookieConsentEnabled) {
        track(Object.assign(Object.assign({}, trackConfig), { dataLayerPushInitial: true, googleTagManagerId: GTM_PROVIDER_SUPPORT_ID, market: 'US', oneTrust: true, oneTrustDomainScript: '50da44be-0564-43df-b139-329aedcf267b' }));
    }
};
export const useTrackingConsent = (isCookieConsentEnabled, { googleOptimizeId, googleOptimizeTimeout, googleTagManagerAdditionalData, language, loggedIn, userCountry, nonce, } = {}) => {
    useEffect(() => {
        setUpTrackJs(isCookieConsentEnabled, {
            googleOptimizeId,
            googleOptimizeTimeout,
            googleTagManagerAdditionalData,
            language,
            loggedIn,
            userCountry,
            nonce,
        });
    }, [
        isCookieConsentEnabled,
        googleOptimizeId,
        googleOptimizeTimeout,
        googleTagManagerAdditionalData,
        language,
        loggedIn,
        nonce,
        userCountry,
    ]);
};
//# sourceMappingURL=useTrackingConsent.js.map